export const immediateInterval = (cb: () => void, period: number) => {
  setTimeout(cb, 0)
  const interval = setInterval(cb, period)
  return function stopTimer() {
    clearInterval(interval)
  }
}
